import {type StatusType} from 'uikit'

type DirtyNumberType = number | undefined | null | string

class Config {
  /** Колличество попыток отгадать слово */
  private _countGuessAttempts: number = 9

  /** Временной лимит поиска буквы в секундах для пользователя */
  private _timeLimitToChooseLetter: number = 30

  /** Включен ли вид клавиатуры по умолчанию или выключен
   *  и тогда отображаются буквы по алфавиту */
  private _letterBoxKeyboard: StatusType = 'on'

  /**  Колличество пропусков уже отгаданных слов при рандомном выборе загадки */
  private _countSkipGuessedRiddles: number = 3

  /** Время анимации закрытия модалки */
  private _modalCloseAnimationTime: number = 400

  set countGuessAttempts(value: DirtyNumberType) {
    if (value && !isNaN(Number(value))) {
      this._countGuessAttempts = Number(value)
    }
  }

  set timeLimitToChooseLetter(value: DirtyNumberType) {
    if (value && !isNaN(Number(value))) {
      this._timeLimitToChooseLetter = Number(value)
    }
  }

  set letterBoxKeyboard(value: StatusType | undefined | null | string) {
    if (value && (value === 'on' || value === 'off')) {
      this._letterBoxKeyboard = value
    }
  }

  set countSkipGuessedRiddles(value: DirtyNumberType) {
    if (value && !isNaN(Number(value))) {
      this._countSkipGuessedRiddles = Number(value)
    }
  }

  set modalCloseAnimationTime(value: DirtyNumberType) {
    if (value && !isNaN(Number(value))) {
      this._modalCloseAnimationTime = Number(value)
    }
  }

  get countGuessAttempts(): number {
    return this._countGuessAttempts
  }

  get timeLimitToChooseLetter(): number {
    return this._timeLimitToChooseLetter
  }

  get letterBoxKeyboard(): StatusType {
    return this._letterBoxKeyboard
  }

  get countSkipGuessedRiddles(): number {
    return this._countSkipGuessedRiddles
  }

  get modalCloseAnimationTime(): number {
    return this._modalCloseAnimationTime
  }
}

export const config = new Config()
